import { createAction, props } from '@ngrx/store';
import { ResponseRetrieveRecipients } from '../../interfaces/retrieve-recipients';
import {
  IDeleteElNoticeboard,
  IPayloadBoardList,
  ResponseComunicationBoardList,
} from '../../interfaces/response-comunication-board-list';
import { ResponseReportBoardList } from '../../interfaces/report-comunicazioni-bacheca';
import { IResponseRichiediExport } from '../../interfaces/richiedi-export';
import { PayloadHeaderDetail } from '../../interfaces/payload-header-detail';
import { IResponseRetrieveHeaderDetail } from '../../interfaces/response-retrieve-header-detail';
import { ResponseMessageBoardList } from '../../interfaces/messaggi-comunicazioni-bacheca';
import { ResponseRecipientsBoardList } from '../../interfaces/destinatari-comunicazioni-bacheca';
import {
  IPayloadSaveDetailMessageBoardList,
  ResponseSaveDetailComunicationBoardList,
} from '../../interfaces/response-save-detail-comunication-board-list';
import {
  IPayloadInvioDetailMessageBoardList,
  ResponseInvioDetailComunicationBoardList,
} from '../../interfaces/response-invio-detail-comunication-board-list';
import { IPayloadSaveDetailMessageBoardListPut } from '../../interfaces/response-save-detail-comunication-board-list-put';
import { IResponseReteTerzaList } from '../../interfaces/response-reteterza-list';
import {
  IPayloadVerifyRecipientsList,
  IResponseVerifyRecipientsList,
} from '../../interfaces/response-verify-recipients-list';
import {
  IPayloadSaveRecipientsList,
  SaveRecipientsList,
} from '../../interfaces/response-save-recipients-list';
import { ResponseIdRecipients } from '../../interfaces/retrieve-id-recipientslist';
import { PayloadEditStateHeader } from '../../interfaces/payload-edit-state-header';

export const RETRIEVE_RECIPIENTS = createAction(
  '[COMMUNICATION] - retrieve recipients'
);

export const RETRIEVE_RECIPIENTS_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve recipients success',
  props<{ responseRecipients: ResponseRetrieveRecipients | null }>()
);

export const RETRIEVE_COMUNICATION_BOARD_LIST = createAction(
  '[COMUNICAZIONE ] - retrieve comunication board list',
  props<{ payload: IPayloadBoardList }>()
);

export const RETRIEVE_COMUNICATION_BOARD_LIST_SUCCESS = createAction(
  '[COMUNICAZIONE] - retrieve comunication board list success',
  props<{ responseBoardList: ResponseComunicationBoardList | null }>()
);

export const RETRIEVE_REPORT_BACHECA = createAction(
  '[COMMUNICATION] - retrieve report bacheca',
  props<{ idBacheca: number }>()
);

export const RETRIEVE_REPORT_BACHECA_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve report bacheca success',
  props<{ responseReportBacheca: ResponseReportBoardList | null }>()
);

export const RICHIEDI_EXPORT = createAction(
  '[COMMUNICATION] - richiedi export',
  props<{ idDestinatari: number }>()
);

export const RICHIEDI_EXPORT_SUCCESS = createAction(
  '[COMMUNICATION] - richiedi export success',
  props<{ responseRequestExport: IResponseRichiediExport | null }>()
);

export const DOWNLOAD_EXPORT = createAction(
  '[COMMUNICATION] - download export',
  props<{ idDestinatari: number; typeComunication: string }>()
);

export const RETRIEVE_LISTA_RETE_TERZA = createAction(
  '[COMMUNICATION] - retrieve rete terza list'
);

export const RETRIEVE_LISTA_RETE_TERZA_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve rete terza list success',
  props<{ responseReteTerzaList: IResponseReteTerzaList }>()
);

export const VERIFY_RECIPIENTS_LIST = createAction(
  '[COMMUNICATION] - verify recipients list',
  props<{ payload: IPayloadVerifyRecipientsList }>()
);

export const VERIFY_RECIPIENTS_LIST_SUCCESS = createAction(
  '[COMMUNICATION] - verify recipients list success',
  props<{
    responseVerifyRecipientsList: IResponseVerifyRecipientsList | null;
  }>()
);

export const SAVE_RECIPIENTS_LIST = createAction(
  '[COMMUNICATION] - save recipients list',
  props<{ payload: IPayloadSaveRecipientsList }>()
);

export const SAVE_RECIPIENTS_LIST_SUCCESS = createAction(
  '[COMMUNICATION] - save recipients list success',
  props<{ responseSaveRecipientsList: SaveRecipientsList | null }>()
);

export const EDIT_RECIPIENTS_LIST = createAction(
  '[COMMUNICATION] - edit recipients list',
  props<{ payload: IPayloadSaveRecipientsList }>()
);

export const EDIT_RECIPIENTS_LIST_SUCCESS = createAction(
  '[COMMUNICATION] - edit recipients list success',
  props<{ responseEditRecipientsList: SaveRecipientsList | null }>()
);

export const RETRIEVE_HEADER_DETAIL = createAction(
  '[COMMUNICATION] - retrieve header detail',
  props<{ idHeader: number }>()
);

export const RETRIEVE_HEADER_DETAIL_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve header detail success',
  props<{
    responseRetrieveHeaderDetail: IResponseRetrieveHeaderDetail | null;
  }>()
);

export const SAVE_HEADER_DETAIL = createAction(
  '[COMMUNICATION] - save header detail',
  props<{ payload: PayloadHeaderDetail }>()
);

export const SAVE_HEADER_DETAIL_SUCCESS = createAction(
  '[COMMUNICATION] - save header detail success',
  props<{ responseSaveHeaderDetail: IResponseRetrieveHeaderDetail | null }>()
);

export const RETRIEVE_MESSAGGI_BACHECA = createAction(
  '[COMMUNICATION] - retrieve messaggi bacheca',
  props<{ idBacheca: number }>()
);

export const RETRIEVE_MESSAGGI_BACHECA_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve messaggi bacheca success',
  props<{ responseMessaggiBacheca: ResponseMessageBoardList | null }>()
);

export const RETRIEVE_DESTINATARI_BACHECA = createAction(
  '[COMMUNICATION] - retrieve destinatari bacheca'
);

export const RETRIEVE_DESTINATARI_BACHECA_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve destinatari bacheca success',
  props<{ responseDestinatariBacheca: ResponseRecipientsBoardList | null }>()
);

export const RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA = createAction(
  '[COMMUNICATION] - retrieve save dettaglio messaggi bacheca',
  props<{ payload: IPayloadSaveDetailMessageBoardList }>()
);

export const RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve save dettaglio messaggi bacheca success',
  props<{
    responseSaveDetailMessageBacheca: ResponseSaveDetailComunicationBoardList | null;
  }>()
);

export const RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA = createAction(
  '[COMMUNICATION] - retrieve invio dettaglio messaggi bacheca',
  props<{ payload: IPayloadInvioDetailMessageBoardList }>()
);

export const RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_PUT = createAction(
  '[COMMUNICATION] - retrieve invio dettaglio messaggi bacheca put',
  props<{ payload: IPayloadInvioDetailMessageBoardList }>()
);

export const RETRIEVE_INVIO_DETTAGLIO_MESSAGGI_BACHECA_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve invio dettaglio messaggi bacheca success',
  props<{
    responseInvioDetailMessageBacheca: ResponseInvioDetailComunicationBoardList | null;
  }>()
);

export const RETRIEVE_SAVE_DETTAGLIO_MESSAGGI_BACHECA_PUT = createAction(
  '[COMMUNICATION] - retrieve save dettaglio messaggi bacheca put',
  props<{ payload: IPayloadSaveDetailMessageBoardListPut }>()
);

export const RETRIEVE_ID_RECIPIENTS = createAction(
  '[COMMUNICATION] - retrieve id recipients',
  props<{ idDestinatari: number }>()
);

export const RETRIEVE_ID_RECIPIENTS_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve id recipients success',
  props<{ responseRetrieveIdRecipients: ResponseIdRecipients | null }>()
);

export const RETRIEVE_HEADER_LIST = createAction(
  '[COMMUNICATION] - retrieve header list'
);

export const RETRIEVE_HEADER_LIST_SUCCESS = createAction(
  '[COMMUNICATION] - retrieve header list success',
  props<{ responseRetrieveHeaderList: IResponseRetrieveHeaderDetail | null }>()
);

export const EDIT_HEADER_STATE = createAction(
  '[COMMUNICATION] - edit header state',
  props<{ payload: PayloadEditStateHeader }>()
);

export const EDIT_HEADER_STATE_SUCCESS = createAction(
  '[COMMUNICATION] - edit header state success',
  props<{ responseEditHeaderState: IResponseRetrieveHeaderDetail | null }>()
);

export const SAVE_EDIT_HEADER_DETAIL = createAction(
  '[COMMUNICATION] - save edit header detail',
  props<{ payload: PayloadHeaderDetail }>()
);

export const SAVE_EDIT_HEADER_DETAIL_SUCCESS = createAction(
  '[COMMUNICATION] - save edit header detail success',
  props<{
    responseEditSaveHeaderDetail: IResponseRetrieveHeaderDetail | null;
  }>()
);

export const DOWNLOAD_EXPORT_BACHECA = createAction(
  '[COMMUNICATION] - download export bacheca',
  props<{ idBacheca: number; typeComunication: string }>()
);

export const DELETE_EL_BACHECA = createAction(
  '[COMMUNICATION] - delete id bacheca list',
  props<{ idBacheca: number }>()
);

export const DELETE_EL_BACHECA_SUCCESS = createAction(
  '[COMMUNICATION] - delete id bacheca list success',
  props<{ responseDeleteElBacheca: IDeleteElNoticeboard | null }>()
);
